export const regularMenuItems = [
  { path: 'translation-editor', label: 'translation editor' },
  { path: 'application-settings', label: 'application settings' },
];

export const adminMenuItem = [{ path: 'admin', label: 'admin panel' }];
